.c37dn30 {
  background-color: var(--pluma-color-surface-content);
  border: var(--pluma-border-width-0125) solid var(--pluma-color-scope-neutral-subtle-border);
  border-radius: var(--pluma-radius-3);
  color: var(--pluma-color-text-primary);
  height: var(--pluma-space-450);
  padding: 0 calc(var(--pluma-space-100) - var(--pluma-border-width-0125));
  width: 100%;
  display: flex;
  align-items: stretch;
  transition: border-color 125ms, outline-color 125ms;
  outline-width: var(--pluma-border-width-025);
  outline-style: solid;
  outline-color: transparent;
  outline-offset: var(--pluma-space-025);
}
.c37dn30 > * {
  flex: 1;
}
.c37dn30.is-focused {
  border-color: var(--pluma-color-scope-accent-border);
  outline-color: var(--pluma-color-scope-focus-border);
}
.c37dn30.is-error {
  border-color: var(--pluma-color-scope-critical-border);
}
.c37dn30:hover:not(.is-focused):not(.is-error) {
  border-color: oklch(from var(--pluma-color-scope-neutral-subtle-border) calc(l + var(--pluma-interaction-text-hover-shift)) c h);
}